module.exports = __webpack_public_path__ + "static/media/amexIcon.aad6b57c.jpeg";